import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import introStyles from '../IntroPage/IntroPage.module.scss'
import {
  prepText,
  scoreBucket,
} from 'components/modals/TestsReportModal/tabs/helpers'
import { useTrait } from 'components/modals/TestsReportModal/tabs/Trait/hooks'
import styles from './Personality.module.scss'
import reportStyles from '../../Report.module.scss'
import { LabeledScale } from 'components/shared/DoubleEndedScale/DoubleEndedScale'

export const PersonalityTrait = ({
  factor,
  language,
  scores,
  groups,
  response,
  isCandidate = false,
}) => {
  const { state } = useTrait({
    factor,
    language,
    scores,
    response,
    isCandidate,
  })

  const getScale = data => {
    return (
      <div key={data.label} className={styles.attribute}>
        <div className={styles.marker} />
        <div className={styles.content}>
          <div>
            <p className={styles.description}>
              <span>{data.label} </span>
              <span>
                {
                  prepText(data.label)(
                    data.abstract.replace('{Trait}', ''),
                  )[0].split('. ')[0]
                }
              </span>
            </p>
          </div>
          <div className={styles.scale}>
            <LabeledScale
              lowLabel={data.lowLabel}
              highLabel={data.highLabel}
              scores={data.scores}
              key={data.label}
              single
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <Box
      className={reportStyles.containerWhite}
      direction="column"
      id="report"
      data-testid="report"
    >
      <div
        className={cx(
          introStyles.header,
          introStyles.headerPadding,
          styles.header,
        )}
      >
        <div className={introStyles.name}>{state.label[0]}</div>
        <div className={styles.score}>
          <div className={styles.scoreNumber}>{`${Math.round(
            state.score * 100,
          )}/100`}</div>
          <div className={styles.scoreLabel}>{scoreBucket(state.score)[1]}</div>
        </div>
      </div>

      {state.abstract.map((par, index) => (
        <div key={index} className={styles.paragraph}>
          {par}
        </div>
      ))}

      <div className={cx(styles.paragraph, styles.bold)}>
        {state.description}
      </div>

      <div className={styles.attributes}>
        {groups
          ? groups.map(({ traits }) =>
              state.attributes
                .filter(({ id }) => traits.includes(id))
                .map(getScale),
            )
          : state.attributes.map(getScale)}
      </div>
    </Box>
  )
}
